import { useState } from "react";
import {
  MenuItem,
  MenuList,
  Grow,
  Popper,
  ClickAwayListener,
  Paper,
  ButtonGroup,
  Button,
  Loading,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
} from "../../components";
import "./add.scss";
import { useImportContext } from "../../contexts/import.context";
import { voltar } from "../../utils";
import Mousetrap from "mousetrap";

const AddLayout = ({
  id,
  showUpdate,
  formSubmit,
  onClickSalvar,
  onClickLog,
  loading,
  title,
  userLog,
  ButtonMenu,
  actions,
  isFullscreenDialog,
  children,
  actionsTotalizadores,
  submitSimples,
  formState,
  resetFormFunction,
  onClickVoltar,
}) => {
  const opcoes = ["SALVAR E ADICIONAR NOVO"];
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { initialDtos, initialCollapses } = useImportContext();

  const handleClick = () => {
    onClickSalvar(0);
    setOpen(false);
  };

  const handleSubmit = (e) => {
    if (formSubmit) {
      document.getElementById("form-button")?.click();
      return;
    }
    id ? onClickSalvar(e) : handleClick();
  };

  const handleMenuClick = () => {
    onClickSalvar(1);
    setOpen(false);
  };

  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (anchorEl.current && anchorEl.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const voltarInitial = async () => {
    initialDtos();
    initialCollapses();
    resetFormFunction?.();
    if (onClickVoltar) return onClickVoltar();
    await voltar(formState);
  };

  const atalhosAddLayout = [
    {
      keys: ["alt+left"],
      action: async (e) => {
        e.preventDefault();
        await voltar(formState);
        return false;
      },
    },
  ];

  atalhosAddLayout.map(({ keys, action }) => Mousetrap.bind(keys, action));

  Mousetrap.stopCallback = function () {
    return false;
  };

  return (
    <div className={`add-layout-container ${isFullscreenDialog ? "p-4" : ""}`}>
      <Card className="add-layout-card">
        <CardHeader
          title={title}
          action={
            <div className="d-flex align-items-center mx-2">
              {actions}
              {ButtonMenu}
            </div>
          }
          botaoVoltar={!isFullscreenDialog}
          onClickVoltar={voltarInitial}
          userLog={userLog}
          onClickLog={onClickLog}
        />
        <CardContent className="add-layout-card-content rolagem">
          {children}
        </CardContent>
        <CardActions className="card-actions-wrapper">
          <Grid container className="d-flex align-items-center">
            {id ? (
              <Grid item xs={1}>
                {showUpdate ? (
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    bold
                    sx={{ width: "7rem" }}
                  >
                    Atualizar
                  </Button>
                ) : (
                  <Grid sx={{ width: "7rem" }} />
                )}
              </Grid>
            ) : (
              <Grid item xs={1}>
                <ButtonGroup variant="contained" color="primary">
                  <Button onClick={handleSubmit} bold fullWidth>
                    SALVAR
                  </Button>
                  {!submitSimples && (
                    <Button
                      size="small"
                      aria-controls={open ? "split-button-menu" : undefined}
                      aria-expanded={open ? "true" : undefined}
                      aria-label="select merge strategy"
                      aria-haspopup="menu"
                      onClick={handleToggle}
                    >
                      <i
                        className="ph-fill ph-caret-down"
                        style={{ color: "#fff", fontSize: 15 }}
                      ></i>
                    </Button>
                  )}
                </ButtonGroup>
              </Grid>
            )}
            <Grid
              item
              xs={id && !showUpdate ? 12 : 11}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: "2.5rem",
              }}
            >
              {actionsTotalizadores}
            </Grid>
          </Grid>
          <Popper
            open={open}
            anchorEl={anchorEl}
            sx={{ zIndex: 500 }}
            placement="top"
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem>
                      {opcoes.map((option) => (
                        <MenuItem key={option} onClick={handleMenuClick}>
                          {option}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </div>
  );
};

export default AddLayout;
